"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _createCacheProvider = require("../cache/createCacheProvider.js");
const _workerthreadspool = require("@lage-run/worker-threads-pool");
const _runners = require("@lage-run/runners");
const _worker_threads = require("worker_threads");
const _logger = /*#__PURE__*/ _interop_require_default(require("@lage-run/logger"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function setup(options) {
    const { runners, root, cacheOptions } = options;
    const logger = (0, _logger.default)();
    logger.addReporter({
        log (entry) {
            _worker_threads.parentPort.postMessage({
                type: "log",
                ...entry
            });
        },
        summarize () {}
    });
    const { cacheProvider } = await (0, _createCacheProvider.createCache)({
        root,
        logger,
        cacheOptions,
        cliArgs: options.taskArgs,
        skipLocalCache: options.skipLocalCache
    });
    const runnerPicker = new _runners.TargetRunnerPicker(runners);
    return {
        options,
        runnerPicker,
        cacheProvider
    };
}
(async ()=>{
    const { cacheProvider, runnerPicker, options } = await setup(_worker_threads.workerData);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let hashPromiseResolve = (_hash)=>{};
    // main thread sends hash to worker because it keeps a global memory cache of the hashes
    _worker_threads.parentPort.on("message", (data)=>{
        if (data.type === "hash") {
            hashPromiseResolve(data.hash);
        }
    });
    async function getCache(target) {
        const { shouldCache, shouldResetCache } = options;
        let hash = undefined;
        let cacheHit = false;
        if (!shouldCache || !target.cache || !cacheProvider) {
            return {
                hash,
                cacheHit
            };
        }
        // using a special pattern in communicating with the main thread to get the hash for the target
        hash = await new Promise((resolve)=>{
            hashPromiseResolve = resolve;
            _worker_threads.parentPort.postMessage({
                type: "hash"
            });
        });
        if (hash && !shouldResetCache) {
            cacheHit = await cacheProvider.fetch(hash, target);
        }
        return {
            hash,
            cacheHit
        };
    }
    async function saveCache(target, hash) {
        if (!hash || !cacheProvider) {
            return;
        }
        await cacheProvider.put(hash, target);
    }
    async function run(data, abortSignal) {
        const { hash, cacheHit } = await getCache(data.target);
        const cacheEnabled = data.target.cache && options.shouldCache && hash;
        let value = undefined;
        if (!cacheHit || !cacheEnabled) {
            const runner = await runnerPicker.pick(data.target);
            value = await runner.run({
                ...data,
                abortSignal
            });
            await saveCache(data.target, hash);
        }
        return {
            skipped: cacheHit,
            id: data.target.id,
            hash,
            value
        };
    }
    (0, _workerthreadspool.registerWorker)(run);
})();
